import { useUserStore } from '@/user/stores/userStore';

export const parseCurrentWorkspaceName = (name?: string) => {
  const current = useUserStore.getState().currentWorkspace;
  const workspaces = useUserStore.getState().workspaces;

  let words = [];

  if (name) {
    words = name.split(' ');
  } else {
    words = workspaces.find((w) => w.id === current).name.split(' ');
  }

  const capitalizedWords = words.map((word) => {
    const firstLetter = word.charAt(0).toUpperCase();
    const restLetters = word.slice(1);
    return firstLetter + restLetters;
  });

  return capitalizedWords.join(' ');
};
